<template>
    <div class="home" v-loading="isLoading">
      <div class="activity-rule" @click="showToast(true)">活动规则</div>
      <div class="share" v-if="shareImg">
        <img :src="shareImgUrl" class="share-img" @click="appShare">
        分享
      </div>
      <div class="wrap" v-show="indexPageIsShow">
            <section class="activity-bg" :style="{backgroundImage: 'url(\'' + configData.backgroundImage + '\')'}">
                <div class="content-topbox" :style="{backgroundImage: 'url(\''+ configData.logoImage + '\')'}"></div>
                <div class="content-bottbox">
                    <div class="img-wrap">
                        <img :src="configData.envelopeImage">
                    </div>
                    <div class="content-val" v-if="useBrowserH5Flow">
                        <div class="input-wrap">
                            <input v-model="postData.phoneNum" @input="inputPhoeNum" @blur="fixWindow" type="text" placeholder="请正确填写手机号">
                        </div>
                        <div class="input-wrap">
                            <input type="text" placeholder="请输入验证码" @input="getRightCode" @blur="fixWindow" style="padding-right: 30%" v-model="postData.verifyCode">
                            <div class="login-get-code msg" @click="getPhoneCode">{{timeSeconds}}</div>
                        </div>
                        <p class="content-button" @click="getTackets"><img :src="configData.buttonImage"></p>
                        <div class="rule-contain">
                          <div class="rule-item">
                            <div class="checkbox-box" @click="() => { this.checked = !this.checked }">
                              <i
                                class="iconfont-v3"
                                :class="checked ? 'icon-checkbox' : 'icon-radio-normal'"
                              ></i>
                            </div>
                          </div>
                          <div class="desc">
                            我已知悉并同意向亚朵提供下述个人信息 详见
                            <a href="https://mobile.yaduo.com/hy/rule/serviceRule?type=2" class="atour-button link"
                              >《亚朵隐私政策》</a
                            >
                          </div>
                        </div>
                    </div>
                    <div class="content-val-inside content-val-to-use" v-else-if="receivedCoupon">
                        <p class="content-button" @click="goCouponListPage"><img src="https://east-qiniu.yaduo.com/QN/chain/ab9cf21e-cb12-4b6b-8a7e-f320d3a87ec7.jpg"></p>
                    </div>
                    <div class="content-val-inside" v-else>
                        <p class="content-button" @click="getTacketsInApp"><img :src="configData.buttonImage"></p>
                    </div>
                </div>
            </section>
        </div>
      <div class="treatment-list" v-show="!indexPageIsShow">
            <section class="activity-bg" :style="{backgroundImage: 'url(\'' + configData.backgroundImage + '\')'}">
                <div class="content-topbox" style="height: auto">
                    <img :src="configData.logoImage" class="content-logimg" v-if="configData.sort!=3">
                    <img :src="configData.successSubTitle" class="content-logimg" v-if="configData.sort==3">
                    <div class="envelope-prompt" v-if="configData.sort!=3">
                        <p>领取成功</p>
                        <span>优惠券已放入您的会员账户</span>
                    </div>
                </div>
                <div class="tacket-list" :style="configData.marketValue==1?'':(configData.envelopeImage ? ('background: url(' + configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : '')">
                    <ul class="list-css" tabindex='-1' :class="configData.marketValue==1?'newbac-css':'bac-css'" :style="configData.sort==3?'bottom: 16%;':''">
                        <li v-for="(item, index) in listData" :key="index" class="clearfix content-img" :style="configData.successSubTitle?('background:url('+configData.successSubTitle+') no-repeat;background-size: 100% 100%;'):'background:#fff'">
                            <div class="fl price clearfix" :style="configData.successTitle?('background: url('+configData.successTitle+') no-repeat;background-size: 100% 100%;'):''">
                                <p class="">{{item.value}}元</p>
                            </div>
                            <div class="fr content-fr">
                                <p class="count">{{item.disTypeName}}</p>
                                <p class="count" style="color: #FB3653;">x{{item.count || 1}}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="bacbottom-img" v-if="!isThirdParty && configData.buttonUrlType === 1">
                        <!--<p class="content-button" v-if="configData.marketValue!=1" @click="goWechat()" :style="configData.buttonImage?('background: url('+configData.buttonImage+') no-repeat;background-size: 100% 100%;'):''">-->
                            <!--立即使用</p>-->
                        <img @click="useTacket" src='https://wechat-qiniu.yaduo.com/hongbao-Botton@2x.png'/>
                    </div>
                    <div @click="lookTicket" class="look-button" v-if="!isThirdParty && configData.buttonUrlType === 2">去查看</div>
                    <div @click="lookMebers" class="look-button" v-if="!isThirdParty && configData.buttonUrlType === 3">去使用</div>
                </div>
            </section>
        </div>
        <div v-if="iShow">
            <div class="toast-mask" style="display: block;" @click="showToast(false)"></div>
            <div class="toast-body">
                <div class="clearfix">
                    <p class="toast-title">活动介绍</p>
                </div>
                <pre class="toast-msg">{{configData.marketRule}}</pre>
            </div>
        </div>
        <div v-show="showBgMask" class="toast-mask"></div>
        <phone-code ref="phoneCode" @showChange="showChange" :show="phoneCodePending" :phone="postData.phoneNum" :codeType="codeType"></phone-code>
    </div>
</template>

<script>
import { GetConfig, GetTackets, GetTacketList } from '@/query/api'
import { getGTHeaders, isGeetestRequiredCode, loadGTScript, onShowCaptchaForRetry } from '@/utils/geetest'
import phoneCode from './phoneCode'
import { mapState, mapMutations } from 'vuex'
import { appShare } from '@/assets/js/common'
import { goToIndex, goActiveConfiguration, goMebers, wxShare, judgeMiniApp } from '@/assets/js/utils'
import { finderEvtCollect } from '@/assets/js/finder'
import { sm2Encrypt } from '@/utils/sm2Util'
import { isThirdPartySource } from '@/utils/thirdParty'
import axiosConfig from '@/config/config'

export default {
  name: 'HelloWorld',
  data () {
    return {
      checked: false,
      iShow: false,
      phoneCodePending: false,
      indexPageIsShow: true,
      isLoading: false,
      showBgMask: false,
      isGeted: false,
      codeType: 16,
      marketId: '',
      interfaceToken: '',
      postData: {
        phoneNum: '',
        verifyCode: ''
      },
      configData: {
        backgroundImage: '',
        buttonImage: '',
        envelopeImage: '',
        logoImage: '',
        marketRule: '',
        shareUrlImage: '',
        shareUrlTitle: '',
        subTitle: '',
        successSubTitle: '',
        successTitle: '',
        title: '',
        titleImage: '',
        buttonUrlType: ''
      },
      listData: [],
      contGetCode: false,
      shareImg: false,
      inMiniApp: false,
      reciveFlg: false,
      receivedCoupon: false, // 是否已经领券
      shareImgUrl: require('@/assets/img/share.png')
    }
  },
  computed: {
    ...mapState(['timeSeconds']),
    isThirdParty () {
      return isThirdPartySource(this.$route.query)
    },
    useBrowserH5Flow () {
      return this.isThirdParty || (!this.shareImg && !this.inMiniApp)
    }
  },
  methods: {
    ...mapMutations(['timeChange']),
    validateGetCode () {
      this.startPhoneCodeFlow()
    },
    // 验证是否有合理结果
    validate () {
      var headers = getGTHeaders('receive') || {}
      // 如有结果则继续往下执行
      if (this.useBrowserH5Flow) {
        this.queryApiInterface({headers})
      } else if (!this.receivedCoupon) {
        this.geetestData = headers
        this.getTacketsInAppVerify()
      }
    },
    getRightCode () {
      const stringVal = '' + this.postData.verifyCode
      this.postData.verifyCode = stringVal.substr(0, 6)
    },
    fixWindow () {
      window.scrollTo(0, 0)
    },
    showChange (showFlag) {
      this.phoneCodePending = showFlag
    },
    appShare () {
      // app内分享
      appShare(this.configData.shareUrlTitle, this.configData.shareFriendDesc, this.configData.shareUrlImage, location.href)
    },
    showToast (type) {
      this.iShow = type
    },
    tips (msg) {
      this.showBgMask = true
      this.$message({
        message: msg,
        duration: 1000,
        onClose: () => {
          this.showBgMask = false
        }
      })
    },
    finderReport (btnName) {
      const inAtour = !this.isThirdParty && (this.inMiniApp || window.Prius.isInsideApp)
      finderEvtCollect('cooperate_button_click', {
        activeId: this.marketId,
        title: this.configData.title,
        button_name: btnName,
        cooperate_type: inAtour ? 'Inter' : 'outer'
      })
    },
    checkIsGeted () {
      const notInAtour = this.useBrowserH5Flow
      if (localStorage.getItem('isgeted') === 'true' && +localStorage.getItem('activeId') === +this.$route.params.id && notInAtour) {
        this.interfaceToken = localStorage.getItem('interfaceToken')
        this.getTacketList(false)
      } else {
        // localStorage.clear()
        localStorage.setItem('activitySource', this.$route.query.activitySource)
        localStorage.setItem('activeId', this.$route.params.id)
        localStorage.setItem('marketId', this.$route.params.id)
        window.localStorage.setItem('version', '2.6.0')
      }
    },
    listTemp: function (list) {
      let map = {}
      let dest = []
      for (let i = 0; i < list.length; i++) {
        let ai = list[i]
        if (!map[ai.value]) {
          dest.push({
            disTypeName: ai.disTypeName,
            value: ai.value,
            count: 1
          })
          map[ai.value] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.value === ai.value) {
              ++dest[j].count
              break
            }
          }
        }
      }
      return dest
    },
    reportPageView () {
      const inAtour = !this.isThirdParty && (this.inMiniApp || window.Prius.isInsideApp)
      let buttonType = ''
      if (this.receivedCoupon && inAtour) {
        buttonType = '已领取'
      } else if (!this.receivedCoupon && inAtour) {
        buttonType = '可领取'
      } else if (!inAtour) {
        buttonType = '可点击'
      }
      finderEvtCollect('cooperate_page_view', {
        activeId: this.marketId,
        title: this.configData.title,
        activitySource: this.$route.query.activitySource,
        button_type: buttonType,
        cooperate_type: inAtour ? 'Inter' : 'outer'
      })
    },
    getConfig () {
      localStorage.setItem('marketId', this.$route.params.id)
      this.marketId = this.$route.params.id
      GetConfig({
        activitySource: this.$route.query.activitySource,
        activeId: this.$route.query.activeId,
        marketId: this.marketId,
        token: this.useBrowserH5Flow ? '' : localStorage.getItem('interfaceToken')
      }).then(rel => {
        if (rel.retcode === 0) {
          if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) && window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)[0] === 'micromessenger') {
            console.log('在微信111')
            wxShare(location.href, rel.result.shareUrlTitle, rel.result.shareFriendDesc, rel.result.shareUrlImage)
          }
          console.log(rel)
          this.isLoading = false
          this.configData = rel.result
          this.receivedCoupon = this.configData.alreadyReceive

          this.reportPageView()
        } else {
          this.tips(rel.retmsg)
        }
      })
    },
    getPhoneCode () {
      this.finderReport('获取验证码')
      if (!this.postData.phoneNum) {
        this.tips('请输入手机号！')
        return false
      } else if (!(/^1[0-9]{10}$/).test(this.postData.phoneNum)) {
        this.tips('手机号格式不正确！')
        return false
      } else {
        this.startPhoneCodeFlow()
      }
    },
    startPhoneCodeFlow () {
      console.log(this.contGetCode)
      if (!this.contGetCode) {
        localStorage.setItem('phoneNum', sm2Encrypt(this.postData.phoneNum))
        this.phoneCodePending = true
      }
    },

    goCouponListPage () {
      if (this.isThirdParty) {
        return
      }
      this.finderReport('去使用')
      if (this.inMiniApp) {
        console.log('this.configData.buttonUrlType', this.configData.buttonUrlType)
        // 牵手页进入的跳转会员法宝
        if (this.$route.query.source === 'qs' || this.configData.buttonUrlType === 3) {
          const _url = `${axiosConfig.mobileUrl}` + 'marketing/member-toolbox/available?isShare=1&needToken=1&isNeedToken=1&htm_source=activity'
          window.wx.miniProgram.navigateTo({
            url: '/pages/NewWebView/NewWebView?url=' + encodeURIComponent(_url)
          })
        } else if (this.configData.buttonUrlType === 1) {
          console.log('跳转首页')
          window.wx.miniProgram.switchTab({
            url: '/pages/index/index'
          })
        } else {
          window.wx.miniProgram.navigateTo({
            url: `/subpacks/UsuallyModule/CouponsPackage/CouponsPackage?currentTab=0&sortScene=2`,
            success: (res) => {
              console.log(1111, res) // 页面跳转成功的回调函数
            },
            fail: (err) => {
              console.log(2222, err) // 页面跳转失败的回调函数
            }
          })
        }
        return
      }
      this.lookTicket(this.configData.buttonUrlType)
    },
    handleGetToken (res) {
      console.log('getToken--------currentToken', res)
      if (res && res.data && res.data.token) {
        // 回调 token 尚未校验，仅传给领券接口，成功后再写入缓存。
        this.handleQueryTicket(res.data.token)
      }
    },
    handleQueryTicket (currentToken, headers = {}) {
      if (this.reciveFlg) {
        return
      }
      const token = localStorage.getItem('interfaceToken')
      this.finderReport('立即领取')
      let data = {
        marketId: this.marketId,
        activitySource: localStorage.getItem('activitySource'),
        activeId: localStorage.getItem('activeId'),
        token: token || currentToken,
        type: this.codeType
      }
      // 仅非第三方的微信小程序领券时强制校验 token 登录态。
      const shouldForceToken = !this.isThirdParty && this.inMiniApp
      const shouldHandleLoginExpired = !this.isThirdParty && this.inMiniApp
      if (shouldForceToken) {
        data.forceToken = 1
      } else {
         data.forceToken = 0
      }
      this.reciveFlg = true
      GetTackets({ params: data, config: { headers } }).then(rel => {
        this.reciveFlg = false
        if (rel.retcode === 0) {
          localStorage.setItem('isgeted', true)
          localStorage.setItem('token', rel.result.token)
          localStorage.setItem('interfaceToken', rel.result.token)
          this.receivedCoupon = true
          this.tips('领取成功')
        } else if (rel.retcode === 60008) {
          localStorage.setItem('isgeted', true)
          this.receivedCoupon = true
          this.tips(rel.retmsg)
        } else if (this.isLoginExpiredRes(rel) && shouldHandleLoginExpired) {
          this.toLogin()
        } else if (isGeetestRequiredCode(rel)) {
          onShowCaptchaForRetry(() => {
            this.handleQueryTicket(currentToken, getGTHeaders('receive'))
          }, 'receive')
        } else {
          this.tips(rel.retmsg)
        }
      }).catch(() => {
        this.reciveFlg = false
      })
    },
    // 正常的业务逻辑
    getTacketsInAppVerify () {
      const currentToken = localStorage.getItem('currentToken')
      window.localStorage.setItem('fffhhh', 'app点击事件')
      const token = localStorage.getItem('interfaceToken')
      if (!currentToken && !token) {
        window.Prius.loginAndToken({
          listener: this.handleGetToken,
          callId: 'page/login'
        })
        return
      }
      this.handleQueryTicket(token || currentToken)
    },
    // 在小程序或者APP内打开h5
    getTacketsInApp () {
      this.getTacketsInAppVerify()
    },
    // 与 router 及 client-marketing-react 一致的登录态失效判断
    isLoginExpiredRes (rel) {
      return Number(rel.retcode) === 10002 ||
        Number(rel.code) === 10010 || Number(rel.code) === 400020001
    },
    // 仅非第三方微信小程序处理登录失效。
    toLogin () {
      if (this.isThirdParty || !this.inMiniApp) {
        return
      }
      localStorage.removeItem('interfaceToken')
      localStorage.removeItem('currentToken')
      window.wx.miniProgram.navigateTo({
        url: '/pages/Login/Login?isMemberPage=1'
      })
    },
    queryApiInterface (geeData) {
      try {
        this.finderReport('立即领取')
      } catch (e) {

      }
      if (this.useBrowserH5Flow) {
        if (!this.postData.phoneNum) {
          this.tips('请输入手机号！')
          return false
        } else if (!(/^1[0-9]{10}$/).test(this.postData.phoneNum)) {
          this.tips('手机号格式不正确！')
          return false
        }
        if (!this.postData.verifyCode) {
          this.tips('请输入验证码！')
          return false
        }
      }

      let data = {
        phoneNum: sm2Encrypt(this.postData.phoneNum) || null,
        marketId: this.marketId,
        verifyCode: this.postData.verifyCode,
        activitySource: localStorage.getItem('activitySource'),
        activeId: localStorage.getItem('activeId'),
        type: this.codeType
      }
      if (this.reciveFlg) {
        return
      }
      this.reciveFlg = true
      GetTackets({ params: data, config: geeData }).then(rel => {
        this.reciveFlg = false
        if (rel.retcode === 0) {
          localStorage.setItem('isgeted', true)
          localStorage.setItem('token', rel.result.token)
          localStorage.setItem('interfaceToken', rel.result.token)
          localStorage.setItem('tk', rel.result.tk)
          this.interfaceToken = rel.result.token
          this.getTacketList(true)
        } else if (rel.retcode === 60008) {
          localStorage.setItem('isgeted', true)
          localStorage.setItem('interfaceToken', rel.result.token)
          localStorage.setItem('tk', rel.result.tk)
          this.interfaceToken = rel.result.token
          this.getTacketList(true)
        } else if (isGeetestRequiredCode(rel)) {
          onShowCaptchaForRetry(() => {
            this.queryApiInterface({ headers: getGTHeaders('receive') })
          }, 'receive')
        } else {
          this.tips(rel.retmsg)
        }
      }).catch(() => {
        this.reciveFlg = false
      })
    },
    // 浏览器打开 h5 获取手机号
    getTackets () {
      if (!this.checked) {
        this.tips('请先勾选隐私政策')
        return
      }
      this.queryApiInterface({ headers: {} })
    },
    getTacketList (isFirst) {
      if (this.postData.phoneNum || localStorage.getItem('phoneNum')) {
        let data = {
          phoneNum: sm2Encrypt(this.postData.phoneNum) || localStorage.getItem('phoneNum') || null,
          tk: localStorage.getItem('tk'),
          marketId: this.marketId || localStorage.getItem('marketId')
        }
        this.getTacketListApi(data, isFirst)
      } else {
        this.tips('手机号格式不正确！请重新输入手机号')
      }
    },
    getTacketListApi (data, isFirst) {
      GetTacketList(data).then(rel => {
        if (rel.retcode === 0) {
          if (isFirst) {
            this.listData = rel.result
            localStorage.setItem('getTicketTime', Date.now())
          } else {
            this.listData = this.listTemp(rel.result)
          }
          this.indexPageIsShow = false
        } else if (rel.retcode === 10400) {
          this.indexPageIsShow = true
        } else {
          this.tips(rel.retmsg)
        }
      })
    },
    inputPhoeNum () {
      // if (sm2Encrypt(localStorage.getItem('phoneNum')) === this.postData.phoneNum) {
      if (sm2Encrypt(this.postData.phoneNum) === localStorage.getItem('phoneNum')) {
        this.$refs.phoneCode.inspectTime()
      } else {
        this.timeChange('获取验证码')
        clearInterval(this.$refs.phoneCode.timeInterval)
        this.contGetCode = false
        this.phoneCodePending = false
      }
    },
    useTacket () {
      if (this.isThirdParty) {
        return
      }
      this.finderReport('去使用')
      goToIndex(this.interfaceToken)
    },
    lookTicket (UrlType) {
      if (this.isThirdParty) {
        return
      }
      this.finderReport('去查看')
      goActiveConfiguration(UrlType, this.interfaceToken)
    },
    lookMebers () {
      if (this.isThirdParty) {
        return
      }
      this.finderReport('去使用')
      if (!this.shareImg && !this.inMiniApp) {
        console.log('this.interfaceToken=====', this.interfaceToken)
        goMebers(this.interfaceToken)
      } else {
        goMebers()
      }
    }
  },
  beforeCreate () {
    this.isLoading = true
  },
  async created () {
    console.log('灰度------', this.$route)
    loadGTScript(this.validateGetCode, 'getCode')
    loadGTScript(this.validate, 'receive')
    localStorage.removeItem('token')

    if (!this.isThirdParty && window.Prius && window.Prius.isInsideApp) {
      this.shareImg = true
    }
    if (!this.isThirdParty) {
      try {
        const { type } = await judgeMiniApp()
        if (type === 'wechat') {
          this.inMiniApp = true
        }
      } catch (error) {
        console.log('error-----', error)
      }
    }

    const { needToken } = this.$route.query || {}
    const token = localStorage.getItem('interfaceToken')

    const { tokenValidationError } = this.$route.meta
    const shouldHandleLoginExpired = !this.isThirdParty && this.inMiniApp
    if (shouldHandleLoginExpired && tokenValidationError && this.isLoginExpiredRes(tokenValidationError)) {
      this.toLogin()
      return
    }

    if (!this.isThirdParty && this.inMiniApp && !token) {
      console.warn('this.inMiniApp && !token')
      // const _url = getUrlQueryObj(window.location.href.split['?'][0], {...this.$route.query, needToken: 1})
      const _url = `${window.location.href}&isNeedToken=1`
      window.wx.miniProgram.redirectTo({
        url: '/pages/NewWebView/NewWebView?url=' + encodeURIComponent(_url)
      })
      return
    }

    if (this.inMiniApp || this.shareImg) {
      needToken && localStorage.setItem('needToken', needToken)
      token && localStorage.setItem('token', token)
    }
    // 获取页面配置资源
    this.getConfig()
    this.checkIsGeted()
  },
  watch: {
    timeSeconds (newVal) {
      this.contGetCode = (newVal !== '重新获取')
    }
  },
  components: {
    phoneCode
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    @import "../assets/css/base.css";
    @import "../assets/css/common.css";
    @import "../assets/css/iconFont.css";
    .home {
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    .share {
        width: 38px;
        height: 38px;
        padding: 3px;
        color:#333333;
        font-weight: 500;
        position: absolute;
        top: 0.4rem;
        right: 0.35rem;
        z-index: 99999;
        background-color: #FFFEFA66;
        display: flex;
        flex-direction:column;
        align-items:center;
        border-radius: 50%;
    }
     .share-img {
         width:18px;
         height:18px;
      }

    .activity-rule{
        position: absolute;
        top: 0.6rem;
        left: 0;
        z-index: 99999;
        width:66px;
        height:28px;
        background-color: #FFFEFA66;
        padding:5px 8px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
        color:#333333;
        font-weight: 500;
    }

    .toast-body.toast-keep {
        background: rgba(255, 255, 255, .9);
        padding: 0.2rem;
        width: 80%;
        left: 10%;
        top: 15%;
        max-height: 70%;
        overflow-y: scroll;
    }

    .toast-msg {
        color: #666;
        padding: 0.13rem 0 0.26rem;
        font-weight: 300;
        line-height: 1.75em;
        text-align: left;
        max-height: 25em;
        font-size: 0.3rem;
    }

    .toast-confirm {
        width: 100%;
    }

    .toast-btn {
        display: inline-block;
        background: #fff;
        line-height: 0.53rem;
        font-size: 0.21rem;
        border-top: 1px solid #eee;
        color: #333;
        font-weight: 400;
        cursor: pointer;
    }

    .toast-back {
        border-right: 1px solid #eee;
    }
    .toast-title {
        color: rgb(102, 102, 102);
        border-bottom: 1px solid rgb(221, 221, 221);
        margin: 0 auto;
        display: inline-block;
        padding: 0.08rem 0;
        height: 0.66rem;
        line-height: 0.66rem;
        font-size: 0.35rem;
    }
    .el-message {
        min-width: auto;
        top: 50%;
        background: rgba(0, 0, 0, .7);
        padding: 0.26rem 0.4rem;
        font-weight: 700;
        border: none;
    }
    .el-message__content {
        color: #fff !important;
        line-height: 0.8rem;
    }
    .el-message__icon {
        display: none;
    }

    .wrap {
        height: 100%;
        margin: 0 auto;
        position: relative;
    }
    .activity-bg {
        width: 100%;
        display: inline-block;
        height: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }
    .activity-bg img {
        width: 100%;
        max-height: 100%;
    }

    .content-topbox {
        width: 80%;
        height: 2.5rem;
        margin: 0 auto;
        text-align: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
    }
    .content-bottbox {
        margin-top: 88px;
    }
    .content-val {
        width: 100%;
        height: 55%;
        margin-top: 60px;
    }
    .content-val-inside {
        margin-top: 60px;
    }
    .login-get-code {
        position: absolute;
        right: 11%;
        top: 50%;
        border: none;
        padding: 0 0.06rem;
        font-size: 0.4rem;
        line-height: 0.8rem;
        color: #7C7358;
        height: 0.8rem;
        margin-top: -0.4rem;
        text-align: center;
        border-left: 1px solid #979797;
        min-width: 4em;
    }
    .content-button {
        width: 84%;
        color: #fff;
        font-size: 0.24rem;
        font-weight: 900;
        margin: 0 auto;
    }

    .input-wrap input {
        width: 67%;
        height: 0.93rem;
    }

    .img-wrap {
        width: 80%;
        margin: 0 auto;
    }
    .input-wrap {
        position: relative;
        margin-bottom: 0.5rem;
        text-align: center;
    }

    .input-wrap input {
        padding: 0 0.8rem;
        border: none;
        background: #FFFFFF;
        border-radius: 0.8rem;
        height: 1.28rem;
        width: 80%;
        outline: none;
        font-size: 0.4rem;
        text-align: left;
        box-sizing: border-box;
    }
    .treatment-list {
        height: 100%;
    }
    .envelope-prompt {
        margin-bottom: 0.13rem;
    }

    .envelope-prompt p {
        font-family: MicrosoftYaHei-Bold;
        font-size: 0.96rem;
        color: #F7DD28;
        letter-spacing: 0;
        text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
    }

    .envelope-prompt span {
        font-family: MicrosoftYaHei;
        font-size: 0.42rem;
        color: #FFFFFF;
        text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
    }
    .list-css {
        width: 81%;
        overflow: auto;
        border-radius: 0.13rem;
        padding: 0.13rem;
        min-height: 100px;
        max-height: 70%;
        overflow-y: scroll;
        margin: 0 auto;
        outline: none;
    }

    .newbac-css {
        /* height: 74%; */
        /* background: rgba(0, 0, 0, 0.4); */
    }

    .list-css li {
        height: 2rem;
        line-height: 2rem;
        font-size: 0.26rem;
        color: rgb(255, 255, 255);
        padding-right: 6%;
        margin-bottom: 6px;
        /*color: rgb(247, 221, 40);*/
    }

    .price {
        font-family: MicrosoftYaHei-Bold;
        font-size: 0.5rem;
        height: 100%;
        width: 33%;
        text-align: center;
        overflow: hidden;
    }

    .price .span-css {
        font-size: 0.21rem;
        margin-left: 6px;
    }
    .content-fr {
        line-height: 0.8rem;
        padding: 0.28rem 0;
        text-align: right;
        width: 66%;
        overflow: hidden;
    }
    .tacket-list {
        height: 66%;
    }
    .treatment-list .count {
        font-family: PingFangSC-Medium;
        font-size: 0.42rem;
        color: #a6a6a6;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .bacbottom-img {
        width: 81%;
        margin: 0 auto;
    }
    .bacbottom-img img {
        width: 100%;
    }
    .look-button {
        width: 80%;
        height: 1.4rem;
        margin: 0 auto;
        color: #D6A984;
        background: #343434;
        font-size: 0.56rem;
        line-height: 1.4rem;
        border-radius: 0.7rem;
        letter-spacing: 5px;
        text-align: center;
    }
    .rule-contain {
      color: #666666;
      padding: 0 40px;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
    .rule-contain .rule-item {
      display: flex;
      line-height: 30px;
    }
    .rule-contain .checkbox-box {
      flex: 0 0 auto;
      margin-right: 4px;
      width: 24px;
      height: 30px;
      text-align: center;
    }
    .iconfont-v3 {
      color: #9D9C96;
      position: relative;
      top: -9px;
    }
    .rule-contain a {
      color: #666666;
    }
    .rule-contain .iconfont {
      color: #6cbd9b;
    }
    .rule-contain .link {
      text-decoration: underline;
    }
    .icon-checkbox {
      color: #B59E6D;
    }
</style>



// WEBPACK FOOTER //
// src/components/home.vue